<template>
    <div
        class="wrapper"
        :class="[
            { 'nav-open': $sidebar.showSidebar },
            { rtl: $route.meta.rtlActive },
        ]"
    >
        <notifications></notifications>
        <side-bar
            :active-color="sidebarBackground"
            :background-image="sidebarBackgroundImage"
            :data-background-color="sidebarBackgroundColor"
        >
            <mobile-menu></mobile-menu>
            <template slot="links">
                <div
                    v-for="element in sidebarElementsFiltered"
                    v-bind:key="element.name"
                >
                    <sidebar-item v-if="$route.meta.rtlActive" :link="element">
                    </sidebar-item>
                    <sidebar-item v-else :link="element"> </sidebar-item>
                </div>
            </template>
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>
            <div
                :class="{ content: !$route.meta.hideContent }"
                @click="toggleSidebar"
            >
                <zoom-center-transition :duration="200" mode="out-in">
                    <router-view></router-view>
                </zoom-center-transition>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
        document.getElementsByClassName(className)[0].scrollTop = 0;
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}

function reinitScrollbar() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        initScrollbar("sidebar-wrapper");
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
    } else {
        docClasses.add("perfect-scrollbar-off");
    }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import { isIOS } from "mobile-device-detect";

export default {
    components: {
        TopNavbar,
        ContentFooter,
        MobileMenu,
    },
    data() {
        return {
            esIOS: isIOS,
            sidebarBackgroundColor: "black",
            sidebarBackground: "green",
            sidebarBackgroundImage: "",
            sidebarMini: true,
            sidebarImg: true,
            sidebarElements: [
                {
                    name: "patient_list",
                    icon: "dashboard",
                    path: "/",
                    showOnIOS: true,
                    roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                },
                {
                    name: "staff",
                    icon: "supervisor_account",
                    path: "/staff",
                    showOnIOS: false,
                    roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                },
                {
                    name: "management",
                    icon: "build",
                    path: "/management",
                    showOnIOS: false,
                    roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                },
                {
                    name: "orders",
                    icon: "inventory",
                    path: "/orders",
                    showOnIOS: false,
                    roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                },
                {
                    name: "analytics",
                    icon: "analytics",
                    path: "/analytics",
                    showOnIOS: false,
                    roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                },
            ],
        };
    },
    computed: {
        sidebarElementsFiltered: function () {
            let user = JSON.parse(localStorage.getItem("instantcare_user"));

            if (this.sidebarElements && this.sidebarElements.length > 0) {
                return this.sidebarElements.filter((element) => {
                    if (element.roles) {
                        const found = user.roles.some(
                            (r) => element.roles.indexOf(r) >= 0
                        );
                        if (found) {
                            if (this.esIOS && !element.showOnIOS) {
                                return;
                            }
                            return this.sidebarElements.includes(element);
                        }
                    }
                });
            } else {
                return this.sidebarElements;
            }
        },
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        },
    },
    updated() {
        reinitScrollbar();
    },
    mounted() {
        reinitScrollbar();
    },
    watch: {
        sidebarMini() {
            this.minimizeSidebar();
        },
    },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
    from {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
        opacity: 1;
    }
}

.main-panel .zoomIn {
    animation-name: zoomIn95;
}

@keyframes zoomOut95 {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
}

.main-panel .zoomOut {
    animation-name: zoomOut95;
}
</style>
